export const getPlatformApiParams = () => ({
    url: '/api/platforms/',
    method: 'GET',
    params: {},
});
